// Implementacion de manejo de mensajes de LRS, separacion de mensaje y contexto
export function mensajeUsuario (mensajeLrs) {
  var patron = /CONTEXT:/
  var posicion = patron.exec(mensajeLrs)
  if (posicion) {
    return mensajeLrs.substring(0, posicion['index'])
  } else {
    return mensajeLrs
  }
}

export function mensajeContexto (mensajeLrs) {
  var patron = /CONTEXT:/
  var posicion = patron.exec(mensajeLrs)
  if (posicion) {
    return mensajeLrs.substring(posicion['index'])
  } else {
    return null
  }
}

// console.log("I Completo", iCompletoSaveResponse);
// console.log("Coincidencias", pruebaError);
